<template>
    <li class="menu-item mb-5" :class="{'hidden': hide, 'open': open}">
        <a :href="href" class="anchor-menu"><slot></slot></a>
        <span
            v-if="hasChildren"
            class="dropdown-arrow icon-right-open-big ml-4 pl-2"
            @click="toggleSublist(true)"></span>

        <ul v-if="hasChildren" class="nav-submenu list-unstyled pl-4">

            <slot name="submenu"></slot>

            <li class="text-right mt-7" @click="toggleSublist(false)">
                {{ __('site.Back') }} <span class="icon-left-open-big"></span>
            </li>
        </ul>
    </li>
</template>

<script>
    export default {
        props: {
            href: String,
        },

        data: function () {
            return {
                open: false,
                hide: false,
                hasChildren: true,
            }
        },

        mounted: function () {
            bus.$on('menu-item-hide', (hide) => {
                this.hide = hide;
            });
            this.hasChildren = this.$children.length;
        },

        methods: {
            toggleSublist: function (opening) {

                if(typeof this.$el.dataset.unavailable == 'string'){
                    return false;
                }

                if (opening) {
                    bus.$emit('menu-item-hide', true);

                    this.hide = false;

                    let delay = 500;
                    $(this.$el).find('.nav-submenu > li').each(function (index, el) {
                        $(el).css('transition-delay', delay + 'ms');
                        delay += 100;
                    });

                    setTimeout( () => {
                        this.open = true;
                    }, 750);
                }else{
                    bus.$emit('menu-item-hide', false);

                    this.open = false;

                    $(this.$el).find('.nav-submenu > li').each(function (index, el) {
                        $(el).css('transition-delay', '0ms');
                    });
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-bar-menu .menu-item{
        font-size: 1.4rem;
        font-weight: lighter;
        color: $gray-darkest;
        transition: opacity .5s .5s, font-size .5s, margin-bottom .5s;

        > *:hover{
            color: $green-light;
        }

        a {
            color: #535657;
            &:hover {
                text-decoration-color: #535657;
            }
        }

        .nav-submenu{
            height: 0;
            padding-top: 0;
            overflow: hidden;

            li:last-child{
                opacity: 0;
                cursor: pointer;
                color: $green-light;
                font-size: 1.4rem !important;
                transform: translate3d(100%, 0, 0);
                transition: opacity 1s, transform 1s;
            }
        }

        .dropdown-arrow{
            border-left: .1rem solid $gray;
            cursor: pointer;

            &:before{
                transition: transform .5s ease-in-out .2s;
            }
        }

        &.open{
            color: $green-light;

            .dropdown-arrow{
                cursor: default;

                &:before{
                    transform: rotate3d(0, 0, 1, 90deg);
                }
            }

            .nav-submenu{
                height: auto;
                padding-top: 1.5rem;

                li:last-child{
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                }
            }
        }

        &.hidden{
            opacity: 0;
            font-size: 0;
            margin-bottom: 0 !important;
            transition: opacity .5s, font-size .5s .5s, margin-bottom .5s .5s;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MenuItem.vue